import { render, staticRenderFns } from "./UpsertContactPropertyConfig.vue?vue&type=template&id=35a05e4c&scoped=true"
import script from "./UpsertContactPropertyConfig.vue?vue&type=script&lang=js"
export * from "./UpsertContactPropertyConfig.vue?vue&type=script&lang=js"
import style0 from "./UpsertContactPropertyConfig.vue?vue&type=style&index=0&id=35a05e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a05e4c",
  null
  
)

export default component.exports